// Tyler.API.MetaData.SaveHandlingType
export enum SaveHandlingType {
    Default = 0,
    Immediate = 1,
    Delay = 2
}
